import React from 'react';
import { useLocation } from 'react-router-dom';
import { parseQuery } from '../../core/helpers/parseQuery';
import { DefaultQueryParams } from '../../core/constants/defaultQueryParams';

function ApplicationWrapper({ children, isOpenPopup }) {
  const { search } = useLocation();
  const { [DefaultQueryParams.Culture]: culture } = parseQuery(search);
  return (
    <div className={`cpt-wrapper ${culture} ${isOpenPopup ? 'disabled-hidden' : ''}`}>
      <div className='cpt-wrapper-inner'>{children}</div>
    </div>
  );
}
export default ApplicationWrapper;
